__webpack_require__.p = "https://akhneve.github.io/aakash-neve-resume/";